import { createFileRoute, redirect } from "@tanstack/react-router"
import { homePath } from "@/lib/permissions"

export const Route = createFileRoute("/_app/")({
  beforeLoad: ({ context }) => {
    throw redirect({ to: homePath(context.session), replace: true })
  },
})
